import "./column-components.22e8302d.js";
import {useState as $9GQfZ$useState, useContext as $9GQfZ$useContext} from "react";
import $9GQfZ$macrostrathyper from "@macrostrat/hyper";
import $9GQfZ$reactimages, {ModalGateway as $9GQfZ$ModalGateway, Modal as $9GQfZ$Modal} from "react-images";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $3814059aab5f7e30$exports = {};

$parcel$export($3814059aab5f7e30$exports, "PhotoOverlay", () => $3814059aab5f7e30$export$24f17aabaa7629ce);
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ 



var $irIdW = parcelRequire("irIdW");
const $3814059aab5f7e30$var$PhotoGallery = function(props) {
    const { images: images, isOpen: isOpen = false, onClose: onClose, ...rest } = props;
    // We just disable this until we figure it out.
    //return null;
    const [ix, setIndex] = (0, $9GQfZ$useState)(0);
    const increment = (step)=>function() {
            const newIx = (ix + step) % images.length;
            return setIndex(newIx);
        };
    return (0, $9GQfZ$macrostrathyper)((0, $9GQfZ$ModalGateway), null, [
        (0, $9GQfZ$macrostrathyper).if(isOpen)((0, $9GQfZ$Modal), {
            onClose: onClose
        }, [
            (0, $9GQfZ$macrostrathyper)((0, $9GQfZ$reactimages), {
                views: images,
                currentIndex: ix,
                ...rest
            })
        ])
    ]);
};
function $3814059aab5f7e30$export$24f17aabaa7629ce(props) {
    // TODO: figure out web error "Cannot find module `fscreen`"
    const { photos: photos, computePhotoPath: computePhotoPath } = (0, $9GQfZ$useContext)((0, $irIdW.PhotoLibraryContext));
    if (photos == null) return null;
    const { photoIDs: photoIDs, ...rest } = props;
    const displayedPhotos = photoIDs.map((id)=>{
        return photos.find((d)=>d.id === id);
    });
    const getPaths = function(d) {
        const src = computePhotoPath(d);
        return {
            src: src,
            caption: d.note
        };
    };
    const images = displayedPhotos.filter((d)=>d != null).map(getPaths);
    return (0, $9GQfZ$macrostrathyper)($3814059aab5f7e30$var$PhotoGallery, {
        images: images,
        ...rest
    });
}


export {$3814059aab5f7e30$export$24f17aabaa7629ce as PhotoOverlay};
//# sourceMappingURL=column-components.b0b42550.js.map
